export default function getDayjsLocale(lang) {
    const localeMap = {vi: "vi", fr: "fr", en: "en"};
    return localeMap[lang] || "en"; // Mặc định là "en"
}
